import { render, staticRenderFns } from "./disclaimers.vue?vue&type=template&id=5b98eaed&scoped=true&"
import script from "./disclaimers.vue?vue&type=script&lang=js&"
export * from "./disclaimers.vue?vue&type=script&lang=js&"
import style0 from "./disclaimers.vue?vue&type=style&index=0&id=5b98eaed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98eaed",
  null
  
)

export default component.exports